import { useEffect } from 'react';

import { CategoryReport, Report, ReportApi } from 'apis/ReportApi';
import { useNotification } from 'app/notifications';
import { useSuperState } from 'hooks';
import { useIntl } from 'react-intl';

export interface ReportCatalog {
    customReports: Report[];
    listOfReports: CategoryReport[];
    loaded: boolean;
    reload: () => Promise<void>;
}

/** Loads the report catalog (categories + custom reports) from the API. */
export const useReportCatalog = (): ReportCatalog => {

    const { formatMessage } = useIntl();
    const { catchWithToast, createToast } = useNotification();

    const [state, setState] = useSuperState({
        customReports: [] as Report[],
        listOfReports: [] as CategoryReport[],
        loaded: false
    });
    const { customReports, listOfReports, loaded } = state;

    const load = async () => {

        // Custom Reports ("My Reports") are temporarily disabled. Re-enable by
        // restoring the GetCustomReports call below and wiring `custom` into setState.
        // const custom = await ReportApi.GetCustomReports()
        //     .catch(err => {
        //
        //         catchWithToast('Failed to load custom reports.')(err);
        //         return [] as Report[];
        //
        //     });
        const custom: Report[] = [];

        const categories = await ReportApi.GetAll()
            .catch(() => {

                createToast(
                    formatMessage({ id: 'unable_to_get_list_of_reports.3fa8e203', defaultMessage: 'Unable to get list of reports' }),
                    'danger'
                );
                return [] as CategoryReport[];

            });

        setState({ customReports: custom, listOfReports: categories, loaded: true });

    };

    useEffect(() => {

        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps

    }, []);

    return { customReports, listOfReports, loaded, reload: load };

};
